<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@gat-ship/vue-components'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    label?: string
  }>(),
  {
    label: 'Sections'
  }
)
</script>

<template>
  <div :class="cn(
    'bg-background shadow-xs ring-border w-fit shrink-0 grow-0 self-start rounded-sm p-2.5 ring-1 ring-inset',
    props.class
  )
    ">
    <h4 class="text-soft/80 mb-2 select-none px-2 py-1 text-xs font-medium uppercase"
      :style="{ letterSpacing: '0.05em' }">
      {{ label }}
    </h4>
    <div role="tablist" aria-orientation="vertical" class="w-full space-y-2" tabindex="0" data-orientation="vertical"
      style="outline: none">
      <slot />
    </div>
  </div>
</template>
